/**
 * Evercleaner Meta Pixel bridge — sitewide funnel accuracy.
 * Pixel bootstrap stays with Shopify Facebook app / WeTracked; this emits
 * standard events on pixel 2823255501225652 with eventID dedupe.
 */
(function () {
  if (window.__ecMetaPixelInit) return;
  window.__ecMetaPixelInit = true;

  var ctx = window.__ecMeta || {};
  var PIXEL_ID = String(ctx.pixelId || '2823255501225652');
  var DEDUP_MS = 5000;
  var SESSION_DEDUP_MS = 30 * 60 * 1000;
  var FBQ_WAIT_MS = 15000;
  var VC_GAP_WAIT_MS = 1400;
  var CHECKOUT_FLUSH_MS = 850;
  var recent = {};
  var pendingFlushTimer = null;
  var lastCheckoutPayload = null;
  var lastViewContentKey = null;

  function currencyCode() {
    return (
      ctx.currency ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      'USD'
    );
  }

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function storageGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (e) {}
  }

  function once(key, fn, ttl) {
    var now = Date.now();
    var windowMs = ttl || DEDUP_MS;
    if (recent[key] && now - recent[key] < windowMs) return false;

    var stored = storageGet('ecmeta:' + key);
    if (stored && now - Number(stored) < windowMs) {
      recent[key] = Number(stored);
      return false;
    }

    recent[key] = now;
    storageSet('ecmeta:' + key, String(now));
    fn();
    return true;
  }

  function eventId(prefix, parts) {
    return ['ec', prefix]
      .concat(parts || [])
      .concat([Date.now().toString(36), Math.random().toString(36).slice(2, 8)])
      .join('-');
  }

  function whenFbq(cb) {
    if (typeof window.fbq === 'function') {
      cb();
      return;
    }
    var started = Date.now();
    var timer = window.setInterval(function () {
      if (typeof window.fbq === 'function') {
        window.clearInterval(timer);
        cb();
        return;
      }
      if (Date.now() - started > FBQ_WAIT_MS) window.clearInterval(timer);
    }, 80);
  }

  function trackFbq(eventName, params, eid) {
    whenFbq(function () {
      try {
        if (eid) {
          window.fbq('trackSingle', PIXEL_ID, eventName, params || {}, { eventID: eid });
        } else {
          window.fbq('trackSingle', PIXEL_ID, eventName, params || {});
        }
      } catch (e) {}
    });
  }

  function publishShopify(name, payload) {
    try {
      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function'
      ) {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (e) {}
  }

  function dollarsFromCents(cents) {
    var n = Number(cents);
    if (!isFinite(n)) return 0;
    return Math.round(n) / 100;
  }

  function metaEventSeen(eventName) {
    try {
      var entries = performance.getEntriesByType('resource');
      for (var i = 0; i < entries.length; i++) {
        var name = entries[i].name || '';
        if (name.indexOf('facebook.com/tr') === -1) continue;
        try {
          if (new URL(name).searchParams.get('ev') === eventName) return true;
        } catch (e) {}
      }
    } catch (e2) {}
    return false;
  }

  function applyAdvancedMatching() {
    var user = ctx.userData;
    if (!user || (!user.em && !user.ph && !user.external_id && !user.fn)) return;

    once(
      'am:' + (user.external_id || user.em || user.ph),
      function () {
        whenFbq(function () {
          try {
            window.fbq('init', PIXEL_ID, user);
          } catch (e) {}
        });
      },
      SESSION_DEDUP_MS
    );
  }

  function normalizeLine(item) {
    if (!item || item.status === 'error' || item.message) return null;
    if (item.items && item.items.length) {
      return item.items.map(normalizeLine).filter(Boolean);
    }
    if (!item.variant_id && !item.id) return null;

    var qty = item.quantity || 1;
    var lineCents =
      item.final_line_price ||
      item.line_price ||
      (item.final_price != null ? item.final_price * qty : null) ||
      (item.price != null ? item.price * qty : 0);
    var unitCents =
      item.final_price != null
        ? item.final_price
        : item.price != null
          ? item.price
          : qty
            ? lineCents / qty
            : 0;

    return {
      productId: String(item.product_id || (ctx.product && ctx.product.id) || ''),
      variantId: String(item.variant_id || item.id || ''),
      name: item.product_title || item.title || (ctx.product && ctx.product.title) || '',
      quantity: qty,
      value: dollarsFromCents(lineCents),
      itemPrice: dollarsFromCents(unitCents),
      sku: item.sku || ''
    };
  }

  function metaParamsFromLines(lines) {
    var list = Array.isArray(lines) ? lines : [lines];
    var contentIds = [];
    var contents = [];
    var value = 0;
    var name = '';
    var numItems = 0;

    list.forEach(function (line) {
      if (!line || !line.variantId) return;
      contentIds.push(line.variantId);
      contents.push({
        id: line.variantId,
        quantity: line.quantity,
        item_price: line.itemPrice
      });
      value += line.value;
      numItems += line.quantity;
      if (!name) name = line.name;
    });

    return {
      content_ids: contentIds,
      content_type: 'product',
      content_name: name,
      contents: contents,
      value: Math.round(value * 100) / 100,
      currency: currencyCode(),
      num_items: numItems
    };
  }

  function trackAddToCart(raw, extras) {
    extras = extras || {};
    var normalized = normalizeLine(raw);
    if (!normalized) return;
    var lines = Array.isArray(normalized) ? normalized : [normalized];
    if (!lines.length) return;

    if (extras.valueCents != null && extras.valueCents !== '') {
      var totalValue = dollarsFromCents(extras.valueCents);
      var qty = extras.quantity || lines[0].quantity || 1;
      lines[0].value = totalValue;
      lines[0].quantity = qty;
      lines[0].itemPrice = qty ? Math.round((totalValue / qty) * 100) / 100 : totalValue;
    }

    var key = lines
      .map(function (l) {
        return ['atc', l.variantId, l.quantity, Math.round(l.value * 100)].join(':');
      })
      .join('|');

    once(key, function () {
      var params = metaParamsFromLines(lines);
      if (!params.content_ids.length) return;
      var eid = eventId('atc', [lines[0].variantId, lines[0].quantity]);

      trackFbq('AddToCart', params, eid);
      lastCheckoutPayload = params;

      lines.forEach(function (line) {
        publishShopify('product_added_to_cart', {
          event_id: eid,
          productVariant: {
            product: {
              id: line.productId ? 'gid://shopify/Product/' + line.productId : undefined,
              title: line.name
            },
            id: 'gid://shopify/ProductVariant/' + line.variantId,
            title: line.name,
            price: {
              amount: String(line.itemPrice),
              currencyCode: currencyCode()
            },
            sku: line.sku
          },
          quantity: line.quantity,
          cartLine: {
            quantity: line.quantity,
            merchandise: {
              id: 'gid://shopify/ProductVariant/' + line.variantId,
              product: {
                id: line.productId ? 'gid://shopify/Product/' + line.productId : undefined,
                title: line.name
              }
            },
            cost: {
              totalAmount: {
                amount: String(line.value),
                currencyCode: currencyCode()
              }
            }
          }
        });
      });
    });
  }

  function trackViewContent(productOverride, force, offer) {
    offer = offer || {};
    var product = productOverride || ctx.product;
    if (!product || !(product.variantId || product.id)) return;

    var variantId = String(product.variantId || product.id);
    var productId = String(product.id || '');
    var qty = offer.quantity || (ctx.defaultOffer && ctx.defaultOffer.quantity) || 1;
    var value =
      offer.valueCents != null
        ? dollarsFromCents(offer.valueCents)
        : offer.value != null
          ? Number(offer.value)
          : (Number(product.price) || 0) * qty;
    var contentKey = [
      variantId,
      qty,
      Math.round(value * 100),
      offer.subscribe ? 'sub' : 'once'
    ].join(':');

    if (lastViewContentKey === contentKey && !force) return;
    lastViewContentKey = contentKey;

    var key = 'vc:' + (window.location.pathname || '') + ':' + contentKey;
    once(
      key,
      function () {
        var eid = eventId('vc', [variantId, qty]);
        var params = {
          content_ids: [variantId],
          content_type: 'product',
          content_name: product.title || '',
          content_category: product.type || product.category || '',
          value: Math.round(value * 100) / 100,
          currency: currencyCode(),
          contents: [
            {
              id: variantId,
              quantity: qty,
              item_price: qty ? Math.round((value / qty) * 100) / 100 : value
            }
          ]
        };

        trackFbq('ViewContent', params, eid);
        publishShopify('product_viewed', {
          event_id: eid,
          productVariant: {
            product: {
              id: productId ? 'gid://shopify/Product/' + productId : undefined,
              title: product.title || '',
              vendor: product.vendor || '',
              type: product.type || ''
            },
            id: 'gid://shopify/ProductVariant/' + variantId,
            title: product.variantTitle || product.title || '',
            price: {
              amount: String(qty ? value / qty : value),
              currencyCode: currencyCode()
            },
            sku: product.sku || ''
          }
        });
      },
      force ? DEDUP_MS : SESSION_DEDUP_MS
    );
  }

  function trackCollectionView() {
    var collection = ctx.collection;
    if (!collection || !(collection.id || collection.handle)) return;

    var collectionKey = String(collection.id || collection.handle);
    var key = 'vcg:' + collectionKey;
    once(
      key,
      function () {
        var eid = eventId('vcg', [collectionKey]);
        var ids = (collection.productIds || []).slice(0, 10).map(String);
        if (!ids.length) ids = [collectionKey];

        trackFbq(
          'ViewContent',
          {
            content_ids: ids,
            content_type: 'product_group',
            content_name: collection.title || collection.handle || '',
            content_category: collection.title || collection.handle || '',
            currency: currencyCode()
          },
          eid
        );
        publishShopify('collection_viewed', {
          event_id: eid,
          collection: {
            id: collection.id ? 'gid://shopify/Collection/' + collection.id : undefined,
            handle: collection.handle || '',
            title: collection.title || ''
          }
        });
      },
      SESSION_DEDUP_MS
    );
  }

  function trackSearch() {
    var search = ctx.search;
    if (!search || !search.query) return;

    var key = 'search:' + String(search.query).toLowerCase();
    once(
      key,
      function () {
        var eid = eventId('search');
        var params = {
          search_string: search.query,
          content_ids: (search.productIds || []).slice(0, 10).map(String),
          content_type: 'product',
          currency: currencyCode()
        };
        trackFbq('Search', params, eid);
        publishShopify('search_submitted', {
          event_id: eid,
          searchResult: {
            query: search.query
          }
        });
      },
      SESSION_DEDUP_MS
    );
  }

  function trackInitiateCheckout(source) {
    once(
      'ic:' + (window.location.pathname || 'x') + ':' + (source || 'nav'),
      function () {
        var eid = eventId('ic');
        var finish = function (cart) {
          var params = {
            content_type: 'product',
            currency: currencyCode(),
            value: 0,
            num_items: 0,
            content_ids: [],
            contents: []
          };

          if (lastCheckoutPayload && lastCheckoutPayload.content_ids && lastCheckoutPayload.content_ids.length) {
            params = Object.assign({}, lastCheckoutPayload);
          } else if (cart && cart.items && cart.items.length) {
            params.value = dollarsFromCents(cart.total_price);
            params.num_items = cart.item_count || 0;
            cart.items.forEach(function (item) {
              var vid = String(item.variant_id || item.id);
              params.content_ids.push(vid);
              params.contents.push({
                id: vid,
                quantity: item.quantity || 1,
                item_price: dollarsFromCents(item.final_price != null ? item.final_price : item.price)
              });
            });
          }

          trackFbq('InitiateCheckout', params, eid);
          publishShopify('checkout_started', {
            event_id: eid,
            currency: params.currency,
            value: params.value,
            num_items: params.num_items
          });
        };

        fetch(rootUrl() + 'cart.js', { credentials: 'same-origin' })
          .then(function (res) {
            return res.ok ? res.json() : null;
          })
          .then(finish)
          .catch(function () {
            finish(null);
          });
      },
      DEDUP_MS
    );
  }

  function flushThenNavigate(url) {
    if (pendingFlushTimer) clearTimeout(pendingFlushTimer);
    pendingFlushTimer = window.setTimeout(function () {
      window.location.href = url;
    }, CHECKOUT_FLUSH_MS);
  }

  function trackAddToCartFromResponse(item, extras) {
    trackAddToCart(item, extras);
    return item;
  }

  function goToCheckout(cartRoot) {
    trackInitiateCheckout('buybox');
    var root = cartRoot || rootUrl();
    flushThenNavigate(root + 'checkout');
  }

  window.__ecMetaPixel = {
    trackAddToCartFromResponse: trackAddToCartFromResponse,
    trackInitiateCheckout: trackInitiateCheckout,
    flushThenNavigate: flushThenNavigate,
    goToCheckout: goToCheckout
  };

  function isCartAddUrl(url) {
    return url && String(url).indexOf('/cart/add') !== -1;
  }

  function isCheckoutIntent(el) {
    if (!el || !el.closest) return null;
    return (
      el.closest(
        [
          'a[href*="/checkout"]',
          'a[href*="checkout"]',
          'button[name="checkout"]',
          '[name="checkout"]',
          '[data-ec-meta-checkout]',
          'shopify-accelerated-checkout',
          '.shopify-payment-button',
          '.shopify-payment-button__button',
          '[data-shopify="payment-button"]'
        ].join(', ')
      ) || null
    );
  }

  function handleCartAddResponse(response) {
    if (!response || !response.ok) return;
    response
      .clone()
      .json()
      .then(function (data) {
        trackAddToCart(data);
      })
      .catch(function () {});
  }

  if (!window.__ecMetaFetchPatched) {
    window.__ecMetaFetchPatched = true;
    var origFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var req = args[0];
      var url = req && req.url ? req.url : req;
      return origFetch.apply(this, args).then(function (res) {
        if (isCartAddUrl(url)) handleCartAddResponse(res);
        return res;
      });
    };
  }

  if (!window.__ecMetaXhrPatched) {
    window.__ecMetaXhrPatched = true;
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__ecMetaUrl = url;
      return origOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      if (isCartAddUrl(xhr.__ecMetaUrl)) {
        xhr.addEventListener('load', function () {
          if (xhr.status < 200 || xhr.status >= 300) return;
          try {
            trackAddToCart(JSON.parse(xhr.responseText));
          } catch (e) {}
        });
      }
      return origSend.apply(this, arguments);
    };
  }

  document.addEventListener('ec-buybox:update', function (event) {
    if (!ctx.isSalesLp || !ctx.product) return;
    var detail = event && event.detail;
    if (!detail || detail.priceCents == null) return;
    trackViewContent(null, true, {
      quantity: detail.quantity || 1,
      valueCents: detail.priceCents,
      subscribe: !!detail.subscribe
    });
  });

  document.addEventListener('variant:add', function (event) {
    var detail = event && event.detail;
    if (!detail) return;
    if (detail.items && detail.items.length) {
      detail.items.forEach(trackAddToCart);
    } else if (detail.variant) {
      trackAddToCart(detail.variant);
    }
  });

  document.addEventListener(
    'click',
    function (event) {
      if (isCheckoutIntent(event.target)) trackInitiateCheckout('click');
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.action) return;
      if (String(form.action).indexOf('/cart') !== -1 && form.querySelector('[name="checkout"]')) {
        trackInitiateCheckout('form');
      }
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      var input = event.target;
      if (!input || input.name !== 'id') return;
      if (!ctx.product || ctx.pageType !== 'product') return;
      var option = input.selectedOptions && input.selectedOptions[0];
      var price = Number(input.getAttribute('data-price') || (ctx.product && ctx.product.price) || 0);
      if (price > 1000) price = price / 100;
      trackViewContent(
        {
          id: ctx.product.id,
          title: ctx.product.title,
          type: ctx.product.type,
          vendor: ctx.product.vendor,
          variantId: input.value,
          variantTitle: (option && option.textContent) || '',
          price: price
        },
        true
      );
    },
    true
  );

  function bootPageEvents() {
    applyAdvancedMatching();

    if (ctx.fireViewContent === 'always' || ctx.fireViewContent === true) {
      var offer = ctx.defaultOffer || {};
      trackViewContent(null, true, offer);
    } else if (ctx.fireViewContent === 'if_missing' && ctx.product) {
      window.setTimeout(function () {
        if (!metaEventSeen('ViewContent')) trackViewContent(null, true);
      }, VC_GAP_WAIT_MS);
    }

    if (ctx.fireCollectionView) trackCollectionView();
    if (ctx.fireSearch) trackSearch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootPageEvents);
  } else {
    bootPageEvents();
  }
})();
